/**
 * PERSO: sous-menu en deux volets (snippets/perso-mega-menu-volets.liquid).
 *
 * Le survol ou le focus d'une catégorie affiche son volet de sous-catégories. Le clic n'est pas intercepté :
 * chaque catégorie reste un lien vers sa collection. Au clavier, flèche droite pour entrer dans les
 * sous-catégories, flèche gauche pour revenir à la catégorie. Sans JavaScript, le premier volet reste visible.
 */

const CATEGORIE = '.perso-volets__categorie';

class PersoMenuVolets extends HTMLElement {
  connectedCallback() {
    this.addEventListener('pointerover', this.#surSurvol);
    this.addEventListener('focusin', this.#surFocus);
    this.addEventListener('keydown', this.#surClavier);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.#surSurvol);
    this.removeEventListener('focusin', this.#surFocus);
    this.removeEventListener('keydown', this.#surClavier);
  }

  /** @param {EventTarget | null} cible */
  #categorieDe(cible) {
    return cible instanceof Element ? cible.closest(CATEGORIE) : null;
  }

  /** @returns {HTMLElement | null} */
  get #categorieActive() {
    const actif = this.querySelector(`${CATEGORIE}[aria-expanded="true"]`);
    return actif instanceof HTMLElement ? actif : null;
  }

  /** @param {Element} categorie */
  #activer(categorie) {
    const rang = categorie.getAttribute('data-perso-volet');
    if (!rang || categorie.getAttribute('aria-expanded') === 'true') return;

    for (const autre of this.querySelectorAll(CATEGORIE)) {
      autre.setAttribute('aria-expanded', autre === categorie ? 'true' : 'false');
    }
    for (const panneau of this.querySelectorAll('.perso-volets__panneau')) {
      panneau.toggleAttribute('hidden', panneau.getAttribute('data-perso-panneau') !== rang);
    }
  }

  /** @param {Event} event */
  #surSurvol = (event) => {
    const categorie = this.#categorieDe(event.target);
    if (categorie) this.#activer(categorie);
  };

  /** @param {FocusEvent} event */
  #surFocus = (event) => {
    const categorie = this.#categorieDe(event.target);
    if (categorie) this.#activer(categorie);
  };

  /** @param {KeyboardEvent} event */
  #surClavier = (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const cible = event.target;
    if (!(cible instanceof HTMLElement)) return;

    if (event.key === 'ArrowRight' && cible.matches(CATEGORIE)) {
      const rang = cible.getAttribute('data-perso-volet');
      const premier = this.querySelector(`.perso-volets__panneau[data-perso-panneau="${rang}"] a`);
      if (premier instanceof HTMLElement) {
        event.preventDefault();
        event.stopPropagation();
        premier.focus();
      }
      return;
    }

    if (event.key === 'ArrowLeft' && cible.closest('.perso-volets__panneau')) {
      const categorie = this.#categorieActive;
      if (categorie) {
        event.preventDefault();
        event.stopPropagation();
        categorie.focus();
      }
    }
  };
}

if (!customElements.get('perso-menu-volets')) {
  customElements.define('perso-menu-volets', PersoMenuVolets);
}
